import PropTypes from 'prop-types';

import { USE_THIS_BILLING_ADDRESS } from 'constants/checkoutButtons';

import styles from 'styles/components/checkout/caap/address/addresslist/billingButtons.scss';

const BillingButtons = (componentParams, { testId }) => {
  const {
    addressId,
    isFetchingCheckoutData,
    onUseThisAddressClick
  } = componentParams;

  return (
    <div>
      <button
        className={styles.checkoutPrimaryButton}
        data-test-id={testId('useThisBillingAddress')}
        disabled={isFetchingCheckoutData}
        id={`${USE_THIS_BILLING_ADDRESS}-${addressId}`}
        onClick={() => onUseThisAddressClick(addressId)}
        type="button">
        Use this address
      </button>
    </div>
  );
};

BillingButtons.contextTypes = {
  testId: PropTypes.func
};

export default BillingButtons;
